import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Building2, CalendarCheck, Wallet, User, Search, Heart, ClipboardList } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useReservationsEnAttente } from '../../hooks/useReservationsEnAttente';
import { permissionsEffectives } from '../../utils/permissions';

const clientItems = [
  { to: '/',                     icon: Search,        label: 'Recherche' },
  { to: '/client/favoris',       icon: Heart,         label: 'Favoris' },
  { to: '/client/reservations',  icon: ClipboardList, label: 'Réservations' },
  { to: '/client/profil',        icon: User,          label: 'Profil' },
];

export default function BottomNav({ badgeCount: badgeCountProp }) {
  const { userProfile, proprietaireId } = useAuth();
  const isGerant = ['gerant', 'sous-gerant'].includes(userProfile?.role);
  // Si le compte est déjà fourni par le parent (AppLayout), on évite d'ouvrir
  // un second listener Firestore identique pour la même donnée.
  const ownBadgeCount = useReservationsEnAttente(badgeCountProp === undefined && isGerant ? proprietaireId : null);
  const badgeCount = badgeCountProp !== undefined ? badgeCountProp : ownBadgeCount;
  const perms = permissionsEffectives(userProfile);

  const gerantItems = [
    { to: '/gerant/dashboard',    icon: LayoutDashboard, label: 'Accueil' },
    { to: '/gerant/residences',   icon: Building2,       label: 'Résidences' },
    perms.voirReservations && { to: '/gerant/reservations', icon: CalendarCheck, label: 'Réservations', badge: badgeCount },
    perms.voirPaiements && { to: '/gerant/paiements',     icon: Wallet,          label: 'Paiements' },
    { to: '/gerant/profil',      icon: User,            label: 'Profil' },
  ].filter(Boolean);

  const items = isGerant ? gerantItems : clientItems;

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0, left: 0, right: 0,
      height: 'var(--bottom-nav)',
      background: 'var(--white)',
      display: 'flex',
      borderTop: '1px solid var(--border)',
      zIndex: 100,
      boxShadow: '0 -4px 20px rgba(0,0,0,0.08)',
    }}>
      {items.map(({ to, icon: Icon, label, badge }) => (
        <NavLink key={to} to={to} style={({ isActive }) => ({
          flex: 1,
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          gap: '2px', position: 'relative',
          color: isActive ? 'var(--primary)' : 'var(--muted)',
          fontSize: '0.65rem', fontWeight: isActive ? 700 : 400,
          textDecoration: 'none', transition: 'color 0.2s', padding: '0.5rem 0',
        })}>
          {({ isActive }) => (
            <>
              <div style={{ position: 'relative' }}>
                <Icon size={20} strokeWidth={isActive ? 2.5 : 1.8} />
                {badge > 0 && (
                  <span style={{
                    position: 'absolute', top: -6, right: -8,
                    background: '#E74C3C', color: 'white',
                    fontSize: '0.6rem', fontWeight: 700,
                    minWidth: 16, height: 16, borderRadius: 8,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    padding: '0 3px', lineHeight: 1,
                  }}>
                    {badge > 99 ? '99+' : badge}
                  </span>
                )}
              </div>
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
